import { Line, Meta } from '@marketing-tool/shared';

export type Status = Line.DeliveryStatus | Meta.EffectiveStatus;

export const formatDeliveryStatus = (status: Status): string => {
    switch (status) {
        case Line.DeliveryStatus.Active:
        case Meta.EffectiveStatus.Active:
            return 'Active';
        case Line.DeliveryStatus.Paused:
        case Meta.EffectiveStatus.Paused:
            return 'Paused';
        case Line.DeliveryStatus.Removed:
            return 'Removed';
        case Line.DeliveryStatus.NotDelivering:
            return 'Not delivering';
        case Line.DeliveryStatus.NotApproved:
            return 'Not approved';
        case Meta.EffectiveStatus.AdsetPaused:
            return 'Ad set paused';
        case Meta.EffectiveStatus.Archived:
            return 'Archived';
        case Meta.EffectiveStatus.CampaignPaused:
            return 'Campaign paused';
        case Meta.EffectiveStatus.Deleted:
            return 'Deleted';
        case Meta.EffectiveStatus.Disapproved:
            return 'Disapproved';
        case Meta.EffectiveStatus.InProgress:
            return 'In progress';
        case Meta.EffectiveStatus.PendingBillingInfo:
            return 'Pending billing info';
        case Meta.EffectiveStatus.PendingReview:
            return 'Pending review';
        case Meta.EffectiveStatus.PreApproved:
            return 'Pre-approved';
        case Meta.EffectiveStatus.WithIssues:
            return 'With issues';
    }
};
